/**
 * Used for smart banners.
 * Reference: https://github.com/BranchMetrics/web-branch-deep-linking
 * Not using the npm package because it fails on SSR
 */
/* global branch */
import { PureComponent } from 'react';
import { connect } from 'react-redux';
import PropTypes from 'prop-types';

import { getWebviewOs } from '@client/redux/modules/clientDevice/selectors';
import { injectConfig, configShape } from '@client/hoc/config';

import { track } from '../../helpers';
import { getCurrentPage } from '../../redux/modules/routing/selectors';
import { getIsTrackingOptedIn } from '../../redux/modules/customer/selectors';

@injectConfig
@connect(state => ({
    isWebview: !!getWebviewOs(state),
    currentPage: getCurrentPage(state),
    isTrackingOptedIn: getIsTrackingOptedIn(state),
}))
export default class BranchIo extends PureComponent {
    static propTypes = {
        isWebview: PropTypes.bool.isRequired,
        isTrackingOptedIn: PropTypes.bool.isRequired,
        currentPage: PropTypes.string.isRequired,
        config: configShape,
    };

    componentDidMount() {
        const { config, isWebview, isTrackingOptedIn } = this.props;

        if (!config.isEnabled('branch_io') || isWebview || !isTrackingOptedIn) {
            return;
        }

        /* eslint-disable */
        (function(b, r, a, n, c, h, _, s, d, k) {
            if (!b[n] || !b[n]._q) {
                for (; s < _.length; ) c(h, _[s++]);
                d = r.createElement(a);
                d.async = 1;
                d.src = 'https://cdn.branch.io/branch-latest.min.js';
                k = r.getElementsByTagName(a)[0];
                k.parentNode.insertBefore(d, k);
                b[n] = h;
            }
        })(
            window,
            document,
            'script',
            'branch',
            (b, r) => {
                b[r] = function() {
                    b._q.push([r, arguments]);
                };
            },
            { _q: [], _v: 1 },
            'addListener applyCode autoAppIndex banner closeBanner closeJourney creditHistory credits data deepview deepviewCta first getCode init link logout redeem referrals removeListener sendSMS setBranchViewData setIdentity track validateCode trackCommerceEvent'.split(
                ' '
            ),
            0
        );
        /* eslint-enable */

        branch.init(config.branchIoKey, {
            disable_exit_animation: true,
            make_new_link: true,
        });
        branch.addListener('willShowJourney', () => {
            track('banner.branch.displayed');
        });
        branch.addListener('didClickJourneyCTA', () => {
            track('banner.branch.clicked');
        });
        branch.addListener('didClickJourneyClose', () => {
            track('banner.branch.closed');
            branch.track('banner.branch.closed');
        });
    }

    componentDidUpdate(props) {
        const { config } = this.props;

        if (typeof branch === 'undefined') {
            return;
        }

        if (this.props.currentPage !== props.currentPage) {
            branch.closeJourney();
            branch.init(config.branchIoKey, {
                disable_entry_animation: true,
                disable_exit_animation: true,
                make_new_link: true,
            });
        }
    }

    render() {
        return null;
    }
}
